/**
 * Number of applications by five underwriting/ re-underwriting, by place of Residence of Insured Person
 */

import {
	isHongKongResident,
	hasLoadings,
	hasExclusions
} from "@/modules/reports/schemas/utils/"

import get from "lodash.get"
import dayjs from "dayjs"

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[1].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 1, c: 4 }
		},
		{
			s: { r: 1, c: 5 },
			e: { r: 1, c: 8 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template A8 - Number of policies effective, by four Underwriting/ Re-underwriting results, by Place of Residence of Insured Person"
	],
	["Place of Residence", "Standard Plan", "", "", "", "Flexi Plan", "", "", ""],
	[
		"",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE"
	]
]

const rows = payload => [
	[
		"Hong Kong",
		countEffectiveStandardOffer(true, payload),
		countEffectiveOfferWithLoadings(true, payload),
		countEffectiveOfferWithExclusions(true, payload),
		countEffectiveOfferWithLoadingsAndExclusions(true, payload)
	],
	[
		"Others",
		countEffectiveStandardOffer(false, payload),
		countEffectiveOfferWithLoadings(false, payload),
		countEffectiveOfferWithExclusions(false, payload),
		countEffectiveOfferWithLoadingsAndExclusions(false, payload)
	]
]

const countEffectiveStandardOffer = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let address = get(policy, "contractInsured[0].addresses")
		let resident = isHongKongResident(address)
		let endDate = get(policy, "endDate", null)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)

		if (
			policy.status === "ISSUED" &&
			resident === isPlaceOfResidence &&
			dayjs().isAfter(endDate) === false &&
			loadings === false &&
			exclusions === false
		) {
			return policy
		}
	}).length
}

const countEffectiveOfferWithLoadings = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let address = get(policy, "contractInsured[0].addresses")
		let resident = isHongKongResident(address)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		let endDate = get(policy, "endDate", null)

		if (
			policy.status === "ISSUED" &&
			loadings === true &&
			exclusions === false &&
			resident === isPlaceOfResidence &&
			dayjs().isAfter(endDate) === false
		) {
			return policy
		}
	}).length
}

const countEffectiveOfferWithExclusions = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let address = get(policy, "contractInsured[0].addresses")
		let resident = isHongKongResident(address)
		let exclusions = hasExclusions(policy)
		let loadings = hasLoadings(policy)
		let endDate = get(policy, "endDate", null)

		if (
			policy.status === "ISSUED" &&
			exclusions === true &&
			loadings === false &&
			resident === isPlaceOfResidence &&
			dayjs().isAfter(endDate) === false
		) {
			return policy
		}
	}).length
}

const countEffectiveOfferWithLoadingsAndExclusions = (
	isPlaceOfResidence,
	payload
) => {
	return payload.filter(policy => {
		let address = get(policy, "contractInsured[0].addresses")
		let resident = isHongKongResident(address)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		let endDate = get(policy, "endDate", null)

		if (
			policy.status === "ISSUED" &&
			loadings &&
			exclusions &&
			resident === isPlaceOfResidence &&
			dayjs().isAfter(endDate) === false
		) {
			return policy
		}
	}).length
}
